import { Pipe } from '@angular/core';
var IsEqualToPipe = (function () {
    function IsEqualToPipe() {
    }
    IsEqualToPipe.prototype.transform = function (input, other) {
        return input == other;
    };
    return IsEqualToPipe;
}());
export { IsEqualToPipe };
IsEqualToPipe.decorators = [
    { type: Pipe, args: [{ name: 'isEqualTo' },] },
];
/** @nocollapse */
IsEqualToPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=is-equal-to.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-equal-to.js
// module id = 220
// module chunks = 4